module.exports = __webpack_public_path__ + "img/rankdone-logo-new.4a1b4671.svg";